import type {ComponentPropsWithoutRef} from 'react';
import React from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';
import styles from './scrollable-area.component.module.styl';

const classNames = withCssModule(styles);

type RightProps = ComponentPropsWithoutRef<'div'>;

export const Right = (props: RightProps) => {
    const {
        children,
        className,
        ...rest
    } = props;

    return (
        <div
            {...rest}
            className={classNames('scrollable-area__right', className)}>
            {children}
        </div>
    );
};
